module.exports = __webpack_public_path__ + "img/icon-home-merah.af8f7fbf.png";